import { styled } from "sharedUI/styles";

export const BoostCheckStyle = styled.div<{ color: string }>`
    position: relative;
    width: 100%;
    max-width: 250px;
    border: 2px solid ${p => p.theme.borderColor};
    background-color: ${p => p.theme.bgColorLight};
    border-radius: 5px;

    padding: 20px 12px;

    display: flex;
    align-items: center;

    user-select: none;

    cursor: pointer;

    transition: border 0.2s;

    .name {
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 2px;
    }

    .price {
        font-weight: 500;
        font-size: 13px;

        color: ${p => p.theme.fgColorMedium};
    }

    .check {
        position: relative;
        height: 20px;
        width: 34px;

        margin-right: 20px;

        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 100px;

        transition: background-color 0.2s;

        .thumb {
            position: absolute;
            left: 2px;
            top: 2px;
            height: 16px;
            width: 16px;

            transition: transform 0.2s;

            border-radius: 100px;

            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

            background-color: white;
        }
    }

    &.enabled {
        border-color: ${p => p.color};

        .thumb {
            transform: translateX(14px);
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
        }

        .check {
            background-color: ${p => p.color};
        }

        .icon {
            color: ${p => p.color};
        }
    }
`;
